// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scrollable-div {
  max-height: 500px; /* Adjust the height as needed */
  min-width: 250px;
  max-width: 250px;
  overflow-y: scroll;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
  padding: 10px;
  cursor: pointer;
  text-overflow: ellipsis;
  overflow-x: hidden;
  white-space: nowrap;


}
.text-search {
  width: 500px;
  padding: 5px;
  border-radius: 4px;
  border: 1px solid #ccc;
}
.amount {
  border: 1px solid #ccc;
  padding: 5px;
  border-radius: 4px;
  background-color: #f9f9f9;
  max-height: 500px; 
  overflow-y: scroll; 
  overflow-x: hidden;
  max-width: 200px;
  min-width: 200px;
}

.scroll-amount {
  overflow-y: scroll;
  max-height: 500px;
}
.form-control{
 max-width: 200px;
}



.move {
  padding-left: 20px; /* Adjust the padding as needed */
  padding-top: 20px;
}

.selected-doatype {
  background-color: #0056b3;
  color: white;
  padding: 5px;
  border-radius: 5px;

}

.button-container {
  background-color: #0056b3;
  color:#ffffff ;
}

.d-flex {
  display: flex;
  gap: 20px; /* Adjust the gap as needed */
}

.title h3 {
  background-color: #6699cc;
  color: #ffffff;
  padding: 10px;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/app/modules/permanentdelegation/managedoatypes/managedoatypes.component.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB,EAAE,gCAAgC;EACnD,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;;;AAGrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;CACC,gBAAgB;AACjB;;;;AAIA;EACE,kBAAkB,EAAE,iCAAiC;EACrD,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;;AAEpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS,EAAE,6BAA6B;AAC1C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB","sourcesContent":[".scrollable-div {\n  max-height: 500px; /* Adjust the height as needed */\n  min-width: 250px;\n  max-width: 250px;\n  overflow-y: scroll;\n  border: 1px solid #ccc;\n  background-color: #f9f9f9;\n  padding: 10px;\n  cursor: pointer;\n  text-overflow: ellipsis;\n  overflow-x: hidden;\n  white-space: nowrap;\n\n\n}\n.text-search {\n  width: 500px;\n  padding: 5px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n}\n.amount {\n  border: 1px solid #ccc;\n  padding: 5px;\n  border-radius: 4px;\n  background-color: #f9f9f9;\n  max-height: 500px; \n  overflow-y: scroll; \n  overflow-x: hidden;\n  max-width: 200px;\n  min-width: 200px;\n}\n\n.scroll-amount {\n  overflow-y: scroll;\n  max-height: 500px;\n}\n.form-control{\n max-width: 200px;\n}\n\n\n\n.move {\n  padding-left: 20px; /* Adjust the padding as needed */\n  padding-top: 20px;\n}\n\n.selected-doatype {\n  background-color: #0056b3;\n  color: white;\n  padding: 5px;\n  border-radius: 5px;\n\n}\n\n.button-container {\n  background-color: #0056b3;\n  color:#ffffff ;\n}\n\n.d-flex {\n  display: flex;\n  gap: 20px; /* Adjust the gap as needed */\n}\n\n.title h3 {\n  background-color: #6699cc;\n  color: #ffffff;\n  padding: 10px;\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
